import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { useTranslation } from 'react-i18next';
import { Section } from '@/shared/ui/layout/Section';
import { PARTY_STATUS_VALUES, type PartyStatus } from '@/shared/ui/chips/PartyStatusChip';
import type { ApiDashboardPartyStatusStat } from '@/shared/types/api/dashboard';

const COLORS: Record<string, string> = {
  COLLECTING: '#64748b',
  SHIPPING: '#06b6d4',
  ON_THE_WAY: '#0ea5e9',
  ON_CUSTOMS: '#f59e0b',
  LOCAL_ON_THE_WAY: '#6366f1',
  SHIPMENT_ON_CUSTOMERS: '#10b981',
};

type Props = { data: ApiDashboardPartyStatusStat[] };

export const FeaturesDashboardPartyStatusChart = ({ data }: Props) => {
  const { t } = useTranslation();
  const formatLabel = (status: string): string => {
    const isKnown = (PARTY_STATUS_VALUES as readonly string[]).includes(status);
    return isKnown ? t(`partyStatus.${status as PartyStatus}`) : status;
  };
  const enriched = data.map((d) => ({
    name: formatLabel(d.status),
    value: d.count,
    color: COLORS[d.status] ?? '#94a3b8',
  }));

  return (
    <Section title={t('dashboard.chart.partiesTitle')} description={t('dashboard.chart.partiesSubtitle')}>
      <div className="h-72 w-full">
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={enriched}
              dataKey="value"
              nameKey="name"
              innerRadius={55}
              outerRadius={95}
              paddingAngle={2}
            >
              {enriched.map((entry) => (
                <Cell key={entry.name} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{
                borderRadius: 12,
                border: '1px solid #e2e8f0',
                boxShadow: '0 6px 24px -8px rgba(15,23,42,0.16)',
              }}
            />
            <Legend wrapperStyle={{ fontSize: 12 }} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </Section>
  );
};
